export var flexGroup = function (_a) {
    var direction = _a.direction, alignItems = _a.alignItems;
    return ({
        display: "flex",
        flexDirection: direction !== null && direction !== void 0 ? direction : "row",
        alignItems: alignItems,
    });
};
export var DISABLED_CURSOR = "not-allowed";
